"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractAllowanceDialog = exports.allowanceValidationSchema = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const inputs_1 = require("../../../../../inputs");
const allowance_amount_input_1 = require("./allowance-amount-input");
var validation_1 = require("./validation");
Object.defineProperty(exports, "allowanceValidationSchema", { enumerable: true, get: function () { return validation_1.allowanceValidationSchema; } });
const ContractAllowanceDialog = () => {
    const { contractType } = (0, react_hook_form_1.useWatch)();
    const handleContractChange = (form) => (_event, option) => {
        form.setValue("contractId", option?.id ?? 0, { shouldDirty: true });
        form.setValue("address", option?.address ?? "0x");
    };
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: contractType !== types_1.TokenType.ERC20 ? [1, 1] : [2], children: [(0, jsx_runtime_1.jsx)(allowance_amount_input_1.AllowanceAmountInput, {}), (0, jsx_runtime_1.jsx)(inputs_1.AllowanceContractInput, { name: "contractId", data: { contractFeatures: [types_1.ContractFeatures.ALLOWANCE], contractModule: [types_1.ModuleType.EXCHANGE] }, onChange: handleContractChange, autoSelect: true, withTokenType: true })] }));
};
exports.ContractAllowanceDialog = ContractAllowanceDialog;
//# sourceMappingURL=index.js.map